import {Injectable} from "@angular/core";
import {Observable, from} from "rxjs";
import {switchMap} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {ApiService} from "@biletix/core/services/api.service";
import {ApiResponse} from "@biletix/core/models/api-response";
import {LocalStorageService} from "@biletix/core/services/local-storage.service";
import {CustomerVerificationRequest} from "@biletix/core/models/customer/customer-verification-request.model";
import {CreateCustomer} from "@biletix/core/models/customer/create-customer.model";
import {environment} from "../../../environments/environment.prod";
import {TurnstileService} from "@biletix/core/services/turnstile.service";
@Injectable()
export class CustomerVerifyService {


  private basePath: string = 'api/v1/customerVerify';

  constructor(private httpClient: HttpClient,
              private apiService: ApiService,
              private turnstileService: TurnstileService,
              private localStorageService:LocalStorageService) {
  }
  sendVerificationCode(info: {email: string, phoneNumber?: string | undefined, type:string}): Observable<ApiResponse<boolean>> {
    return this.httpClient.post<ApiResponse<boolean>>(
      `${this.apiService.getCrmApiHost()}/${this.basePath}/sendVerificationCode`,//
      {...info});//
  }

  verifyCustomer(customerVerificationRequest: CustomerVerificationRequest | any): Observable<ApiResponse<boolean>> {
    if (customerVerificationRequest.type)customerVerificationRequest.type = 'CUSTOMER'
    return this.httpClient.post<ApiResponse<boolean>>(
      `${this.apiService.getCrmApiHost()}/${this.basePath}/verifyCustomer`,//
      {...customerVerificationRequest});//
  }

  sendActivationVerificationCode(info: {email: string, forAnonymousCustomer?:boolean}): Observable<ApiResponse<boolean>> {
    return this.turnstileService.execute('sendActivationCode').pipe(
      switchMap((token: string) => {
        return this.httpClient.post<ApiResponse<boolean>>(
          `${this.apiService.getCrmApiHost()}/${this.basePath}/sendActivationVerificationCode`,
          {...info, captchaResponse: token});
      })
    );
  }


  verifyActivation(customerVerificationRequest: CustomerVerificationRequest | any): Observable<ApiResponse<boolean>> {
    return this.turnstileService.execute('verifyActivation').pipe(
      switchMap((token: string) => {
        return this.httpClient.post<ApiResponse<boolean>>(
          `${this.apiService.getCrmApiHost()}/${this.basePath}/verifyActivation`,
          {...customerVerificationRequest, captchaResponse: token});
      })
    );
  }

  checkPhoneVerified(info: {email: string}): Observable<ApiResponse<boolean>> {
    return this.httpClient.post<ApiResponse<boolean>>(
      `${this.apiService.getCrmApiHost()}/${this.basePath}/checkPhoneVerified`,//
      {...info});//
  }

  sendForgotPasswordVerificationCode(info: {email: string, selectedMethod: string}): Observable<ApiResponse<boolean>> {
    return this.httpClient.post<ApiResponse<boolean>>(
      `${this.apiService.getCrmApiHost()}/${this.basePath}/sendForgotPasswordVerificationCode`,//
      {...info});//
  }

  verifyForgotPasswordCode(customerVerificationRequest: CustomerVerificationRequest | any): Observable<ApiResponse<string>> {
    return this.turnstileService.execute('verifyForgotPasswordCode').pipe(
      switchMap((token: string) => {
        customerVerificationRequest.captchaResponse = token;

        return this.httpClient.post<ApiResponse<string>>(
          `${this.apiService.getCrmApiHost()}/${this.basePath}/verifyForgotPasswordCode`,//
          {...customerVerificationRequest});//
      })
    );
  }


}
